import { createContext, useContext, useMemo, useState } from 'react';

interface AudioPlayerContextProps {
  currentlyPlayingAudioUrl: string | null;
  setCurrentlyPlayingAudioUrl: React.Dispatch<React.SetStateAction<string | null>>;
}

const AudioPlayerContext = createContext<AudioPlayerContextProps | undefined>(undefined);

export const AudioPlayerContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currentlyPlayingAudioUrl, setCurrentlyPlayingAudioUrl] = useState<string | null>(null);
  const value = useMemo(
    () => ({ currentlyPlayingAudioUrl, setCurrentlyPlayingAudioUrl }),
    [currentlyPlayingAudioUrl],
  );

  return <AudioPlayerContext.Provider value={value}>{children}</AudioPlayerContext.Provider>;
};

export const useCurrentPlayingAudioUrl = () => {
  const context = useContext(AudioPlayerContext);
  if (!context) {
    throw new Error('useCurrentPlayingAudioUrl must be used within a AudioPlayerContextProvider');
  }
  return context;
};
